import React, { Component } from 'react'
import { translate } from 'react-i18next'

class Faq extends Component {
  state = {
    isOpen: false,
  }

  onHandleChange = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    })
  }

  render = () => {
    const { isOpen } = this.state
    const { t, ind } = this.props
    return (
      <div className="faq-item">
        <button onClick={this.onHandleChange} className={isOpen ? 'faq-btn faq-btn-open' : 'faq-btn'}>
          <p className="subtitle-1">{t(`about.faq.${ind}.title`)}</p>
        </button>
        {isOpen && (
          <div className="faq-answer">
            <p className="body-light">{t(`about.faq.${ind}.answer`)}</p>
          </div>
        )}
      </div>
    )
  }
}

export default translate('translations')(Faq)
